import React from "react"

export default function Navbar(){
    return (
        <header className="bg-gray-900 md:sticky top-0 z-10">
          <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
            <a className="title-font font-medium text-white mb-4 md:mb-0">
              <a href="#about" className="ml-3 text-xl">
                Daniel Coates
              </a>
            </a>
            <nav className="md:mr-auto md:ml-4 md:py-1 md:pl-4 md:border-l md:border-gray-700	flex flex-wrap items-center text-base justify-center">
              <a href="#projects" className="mr-5 hover:text-white">
                Past Work
              </a>
              <a href="#skills" className="mr-5 hover:text-white">
                Skills
              </a>
              <a href="#testimonials" className="mr-5 hover:text-white">
                Testimonials
              </a>
              <a href="https://docs.google.com/document/d/1S6yH2A2rFegk65YUQ5WqfwLRsWDDdlNQ/edit?usp=sharing&ouid=108375138709124241297&rtpof=true&sd=true" className="mr-5 hover:text-white">
                CV
              </a>
            </nav>
            <a
              href="#contact"
              className="inline-flex items-center bg-gray-800 border-0 py-1 px-3 focus:outline-none hover:bg-gray-700 rounded text-base mt-4 md:mt-0">
              Hire Me
              <div class="flex justify-center items-center h-full">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
                </svg>
                </div>
            </a>
          </div>
        </header>
      );
}


// WEBPACK FOOTER //
// ./src/components/Navbar.js